import { render, staticRenderFns } from "./AreaStat.vue?vue&type=template&id=cf220030&scoped=true"
import script from "./AreaStat.vue?vue&type=script&lang=js"
export * from "./AreaStat.vue?vue&type=script&lang=js"
import style0 from "./AreaStat.vue?vue&type=style&index=0&id=cf220030&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf220030",
  null
  
)

export default component.exports